import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardHeader from './CardHeader';
import DateTimeIntervalDisplay from './DateTimeIntervalDisplay';
import ModalTrigger from './ModalTrigger';

export default class EventRsvpCard extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    answersWithQuestions: PropTypes.string,
    slotStartTime: PropTypes.string.isRequired,
    slotEndTime: PropTypes.string.isRequired,
    author: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    rsvpType: PropTypes.string.isRequired,
    eventVirtualNotes: PropTypes.string,
    userInformation: PropTypes.object.isRequired,
    campus: PropTypes.string,
    useTimezone: PropTypes.string.isRequired,
    showCancelSlotButton: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  toggleExpanded = (e) => {
    e.preventDefault();
    this.setState({ expanded: !this.state.expanded });
  };

  renderCancelSlotButton = () => {
    if (this.props.showCancelSlotButton) {
      return (
        <ModalTrigger
          triggerLabel="Cancel"
          triggerClassName="Button Button--small Button--primary"
          modalContentSelector={`#mentor-cancel-${this.props.id}`}
        />
      );
    }
  };

  render() {
    const happeningNow = moment().isBetween(
      moment(this.props.slotStartTime).tz(this.props.useTimezone),
      moment(this.props.slotEndTime).tz(this.props.useTimezone)
    );

    return (
      <div
        className={`u-mb-4 ${happeningNow && 'is-happening'}`}
        data-card-author={this.props.author.name}>
        <CardHeader author={this.props.author} twoLines />
        <div className="u-font-bold u-mt-4 u-mb-2">
          {this.props.rsvpType === 'in_person' && (
            <span>In Person{this.props.campus && `, ${this.props.campus}`}</span>
          )}
          {this.props.rsvpType === 'virtual' && (
            <div className="u-overflow-hidden">
              Virtual, <span dangerouslySetInnerHTML={{ __html: this.props.eventVirtualNotes }} />
            </div>
          )}
        </div>
        <div className="u-flex u-items-center">
          <div className="u-flex-grow-0">
            <i className="Icon Icon-calendar u-text-grey u-text-lg u-mr-2" />
          </div>
          <div className="u-flex-1 u-text-sm u-mr-2">
            <DateTimeIntervalDisplay
              useTimezone={this.props.useTimezone}
              start_date={this.props.slotStartTime}
              end_date={this.props.slotEndTime}
              show_date={false}
            />
          </div>
          <div className="u-flex-grow-0">{this.renderCancelSlotButton()}</div>
        </div>
      </div>
    );
  }
}
